import { render, staticRenderFns } from "./Trial.vue?vue&type=template&id=3acbe331&lang=pug&"
import script from "./Trial.vue?vue&type=script&lang=ts&"
export * from "./Trial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports